// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useContext } from "react";
import * as React from "react";
import { infoProps } from "@store/Themes/common/props/info";

export interface OrderDetailsWarehouseStyles {
    titleText?: TypographyPresentationProps;
    warehouseText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const carrierStyles: OrderDetailsWarehouseStyles = {
    titleText: infoProps.label,
    warehouseText: infoProps.value,
};

const styles = carrierStyles;

const OrderDetailsWarehouse = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.properties.carrier) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Plant")}
            </Typography>
            <Typography {...styles.warehouseText}>{order.properties.warehouse}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsWarehouse,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
